import { appConstants } from "JS/Helpers/Constants";
import { config } from "JS/Config";
import { DocumentDetails } from "JS/Models";
import { BaseService } from "../BaseService";

export class DocumentsService extends BaseService {
    getDocumentDetails(): Promise<DocumentDetails[]> {
        const basePath = new URL(config.s3.documents.baseUrl).pathname.replace(
            /^\//,
            "",
        );
        return this.ngCall<DocumentDetails[]>(
            "get",
            appConstants.ngEndpoints.s3File,
            {
                params: {
                    bucketName: config.s3.mediaEssentials.bucketName,
                    filePath: `${basePath}/${config.s3.documents.description}`,
                },
            },
        ).then((response) => response.data);
    }
}
